import { ProgressAlertIcon } from './ProgressAlertIcon';

/**
 * author: Michael Richins
 * id 82FBA8C9-B8BE-4CA6-883C-E07C36723627
 * name progress-alert
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/progress-alert.svg
 * tags
 * - Alert / Error 
 */
export const ProgressWarningIcon = ProgressAlertIcon;
export default ProgressWarningIcon